import {
  ExpenseItem,
  ExpenseCategory,
  ExpensesQuery,
  ExpenseStatus,
  ExtraFieldsTable_WithExtraFieldsFragment,
  ManagerExpensesQuery,
} from '../../__generated__/graphql';

export type Expense = Omit<expenseSF, 'project' | 'merchant' | 'employee'> & {
  id: string;
  description: string | null;
  amount: number;
  finalAmount: number | null;
  expenseDate: Date;
  dateFrom: Date | null;
  dateTo: Date | null;
  timeFrom: string | null;
  timeTo: string | null;
  project: string | null;
  merchant: string | null;
  category: ExpenseCategory | null;
  status: ExpenseStatus;
  employee: Colleague;
  documents: DocumentFile[];
  declineReason: string | null;
  name: string;
  isNew: boolean;
  currencyIsoCode: string;
  commentsCount: number;
  expenseItems: ExpenseItem[];
  files: DocumentFile[] | null;
  flair__Expense_Group__c: string | null;
  reimbursed: boolean;
  recordType?: {
    DeveloperName: string;
    Name: string;
  } | null;
} & ExtraFieldsTable_WithExtraFieldsFragment;

export type Colleague =
  | ManagerExpensesQuery['manager']['expenses']['items'][0]['employee']
  | ExpensesQuery['me']['myExpenses'][0]['employee'];

export type ContentDocumentLink =
  | ManagerExpensesQuery['manager']['expenses']['items'][0]['ContentDocumentLinks'][0]
  | ExpensesQuery['me']['myExpenses'][0]['ContentDocumentLinks'][0];

export type expenseSF =
  | ManagerExpensesQuery['manager']['expenses']['items'][0]
  | ExpensesQuery['me']['myExpenses'][0];

export const allExpenseStatuses = [
  ExpenseStatus.Approved,
  ExpenseStatus.Pending,
  ExpenseStatus.Declined,
  ExpenseStatus.Reimbursed,
];

export type ExpenseStatusInfo = {
  expenseId: string;
  status: ExpenseStatus;
  declineReason: string | null;
};

export type ExpenseGroupStatusInfo = {
  expenseGroupId: string;
  status: ExpenseStatus;
  declineReason?: string;
  reimbursed?: boolean;
};

export const isExpenseStatus = (value: string): value is ExpenseStatus => {
  return allExpenseStatuses.some((x) => x === value);
};

export type DocumentFile = {
  id: string;
  fileName: string;
  downloadPublicUrl?: string;
};

export type Option = {
  label: string;
  value: string;
};

export type ExpenseType = 'individual' | 'groups' | 'trips';

export type ExpenseFilter = {
  category: string | null;
  status: string | null;
  year: string | null;
  type: ExpenseType | null;
};

export const emptyExpenseFilter: ExpenseFilter = {
  category: null,
  status: null,
  year: null,
  type: null,
};

// These enums are used in external code
/* eslint-disable no-unused-vars */
export enum ExpenseRecordType {
  PerDiem = 'Per_Diem',
  Reimbursement = 'Reimbursement',
  Mileage = 'Mileage',
}

export enum ExpenseItemRecordType {
  Meal = 'Meal',
  Travel = 'Travel',
  Other = 'Other',
}

export enum MeansOfTransport {
  OwnCar = 'Own Car',
}
/* eslint-enable no-unused-vars */
